import { Box, Grid, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { FieldValues, FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { IWorkspace, getWorkspace } from 'wisestep-api';
import { WsColors, WsTitleBanner, WsPagination } from 'wisestep-base';

import WsSearchFilter from '../../../components/WsSearchFilter';

import WorkspaceDetailsCard from './workspaceDetailsCard/WorkspaceDetailsCard';
import WorkspacesListingSideNav from './workspaceListSideNav/WorkspacesListingSideNav';

const LayoutTheme = styled(Box)(() => ({
  maxWidth: '100%',
  maxHeight: 'xs',
  backgroundColor: WsColors.TertiaryShades50,
  padding: 2,
}));

const WorkspacesListing = () => {
  const navigate = useNavigate();
  const [workspacelist, setWorkspaceList] = useState<IWorkspace[]>([]);
  const methods = useForm();

  const loadWorkspaceList = async (data: any) => {
    const response = await getWorkspace(data.query);
    setWorkspaceList(response.data);
  };

  const loadData = async () => {
    const response = await getWorkspace('');
    setWorkspaceList(response.data);
  };

  useEffect(() => {
    const fetchWorkspaceList = async () => {
      const response = await getWorkspace('');
      setWorkspaceList(response.data);
    };
    fetchWorkspaceList();
  }, []);

  const OnSearch = (data) => {
    loadWorkspaceList(data);
  };
  const clearAllFields = () => {
    methods.reset();
    loadData();
  };

  return (
    <LayoutTheme>
      <FormProvider {...methods}>
        <WsTitleBanner title="Workspace Listing" goBack={() => navigate('/')} />
        <Grid container item xs={12} display="flex" pt={2} spacing={3}>
          <Grid item xs={3}>
            <WorkspacesListingSideNav />
          </Grid>
          <Grid
            item
            xs={9}
            component="form"
            container
            bgcolor={WsColors.White}
            borderRadius={1}
            my={2}
            p={1}
            spacing={2}
            onSubmit={methods.handleSubmit(OnSearch as SubmitHandler<FieldValues>)}
          >
            <Grid item xs={12}>
              <WsSearchFilter
                name="WorkspaceListFilter"
                showDefaultRightActions={false}
                showLeftActions={false}
                clearAllFields={clearAllFields}
                showChildren={false}
                searchPlaceholder="Search by Workspace Name, Workspace link, Team name, Domains"
              />
              <Grid pt={2}>
                {workspacelist.length && workspacelist.length > 50 && (
                  <WsPagination
                    count={Math.ceil(workspacelist.length / 50)}
                    onChange={(_, value) => {
                      methods.setValue('page', value + 1);
                      methods.handleSubmit(loadData)();
                    }}
                    itemsPerPage={50}
                    pageNumber={methods.watch('page') - 1}
                    defaultPage={methods.watch('page')}
                    isPageCount={true}
                    type="Workspace"
                    totalCount={workspacelist.length}
                  />
                )}
                {workspacelist.map((workspace, index) => (
                  <>
                    <WorkspaceDetailsCard
                      key={index}
                      workspaceId={workspace?.id}
                      title={workspace.ownerId}
                      planType={workspace.planType}
                      visibility={workspace.visibility}
                      ownerId={workspace.ownerId}
                      status={workspace.status}
                      ownerName={workspace.ownerName}
                      dateCreated={workspace.createdOn}
                      workspace={workspace}
                    />
                  </>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </FormProvider>
    </LayoutTheme>
  );
};

export default WorkspacesListing;
